import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PushListTemplate } from 'components/Templates'

const PushList: FC = () => {
  return (
    <Layout headline={'配信履歴'} title={'配信履歴'}>
      <PushListTemplate />
    </Layout>
  )
}

export default PushList
